var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.phone)?_c('a',{staticClass:"phone",attrs:{"href":'tel:' + _vm.phoneNoSpaces}},[_vm._v(_vm._s(_vm.phoneFormatted))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }